import { useCallback, useEffect, useState } from "react";
import { fetchUserQualifications, type UserQualification } from "@/api/client";

type UseUserQualificationsState = {
  qualifications: UserQualification[];
  isLoading: boolean;
  error: Error | null;
};

export const useUserQualifications = (userId: string | null) => {
  const [state, setState] = useState<UseUserQualificationsState>({
    qualifications: [],
    isLoading: false,
    error: null,
  });

  const refetch = useCallback(async () => {
    if (!userId) return;

    setState((prev) => ({ ...prev, isLoading: true, error: null }));
    try {
      const data = await fetchUserQualifications(userId);
      setState({ qualifications: data, isLoading: false, error: null });
    } catch (error) {
      setState((prev) => ({
        ...prev,
        isLoading: false,
        error: error instanceof Error ? error : new Error("Failed to fetch user qualifications"),
      }));
    }
  }, [userId]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  // qualificationTypeIdでMapを作成するヘルパー
  const qualificationMap = new Map(state.qualifications.map((q) => [q.qualificationTypeId, q]));

  return {
    ...state,
    qualificationMap,
    refetch,
  };
};
